import React, {Component} from 'react';
import {FormGroup, Label, Row, Col, Card, CardHeader, CardBody, Input, Button, CardFooter, Form} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';

class StoryRequestPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      email:"",
      password:"",
      isLoading: false,
      errorModalOpen: false,
      sections: [{audience:"", client:"", creativeTeam:"",event:"",sponsor:""}]
    };
    this.redirectUpload = this.redirectUpload.bind(this);
    this.postForm = this.postForm.bind(this);
  }

  redirectUpload() {
    this.setState({
      navigate: true,
      path:'YourStoryboards'

    })

  }

  postForm() {
  	var errors = [];
    let storyTitle = $("#storyboard-details-title").val();
    if(storyTitle == ''){
	  errors.push('storyTitle');
	  $("#storyboard-details-title").addClass('error');
    }
    let storyAbout = $("#storyboard-details-about").val();
    if(storyAbout == ''){
	  errors.push('storyAbout');
	  $("#storyboard-details-about").addClass('error');
    }
    let storyGenre = $("#storyboard-details-genre").val();
    let storyLength = $("#storyboard-details-length").val();
    let storyTone = $("#storyboard-details-tone").val();
    let storyCta = $("#storyboard-details-cta").val();
    
    let audienceDemo = $("#audience-demographic").val();
    let audienceLoc = $("#audience-location").val();

    let clientName = $("#client-contact-name").val();
    if(clientName == ''){
	  errors.push('clientName');
	  $("#client-contact-name").addClass('error');
    }
    let clientEmail = $("#client-contact-email").val();
    if(clientEmail == ''){
	  errors.push('clientEmail');
	  $("#client-contact-email").addClass('error');
    }
    
    let creativeVertical = $("#creative-team-vertical").val();
    let creativeAgency = $("#creative-team-agency-name").val();
    let creativeName = $("#creative-team-contact-name").val();
    let creativeEmail = $("#creative-team-contact-email").val();

    let eventName = $("#event-name").val();
    let eventStart = $("#event-start").val();
    let eventEnd = $("#event-end").val();
    
    let dataString = 'storyTitle=' + storyTitle + '&storyAbout=' + storyAbout + '&storyGenre=' + storyGenre + '&storyLength=' + storyLength + '&storyTone=' + storyTone + '&storyCta=' + storyCta + '&audienceDemo=' + audienceDemo + '&audienceLoc=' + audienceLoc + '&clientName=' + clientName + '&clientEmail=' + clientEmail + '&creativeVertical=' + creativeVertical + '&creativeAgency=' + creativeAgency + '&creativeName=' + creativeName + '&creativeEmail=' + creativeEmail + '&eventName=' + eventName + '&eventStart=' + eventStart + '&eventEnd=' + eventEnd;
    
    if(errors.length){
	    console.log(errors);
    } else {
	  $.ajax({
	    type: "POST",
	    url: "http://www.cinefly.io/storyboard-request.php",
	    data: dataString,
	    dataType: 'text',
	    success: function (data) {
	      $('#storyboard-request-form')[0].reset();
	    }
	  });
    }

  }

  validEmail(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
  }

  render() {

     const { navigate, path } = this.state

      // here is the important part
      if (navigate) {
        console.log(path);
        return <Redirect to={ "/" + path } push={true} />
      }

    return (

      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <strong>Story Request</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Form id="storyboard-request-form">
                    <Row className="form-row" form>
                      {/* Storyboard */}
                      <Col xs="12" md="6" className="storyboard-details form-section">
                        <FormGroup>
                          <div className="form-section-title">
                            <b>Storyboard Details</b>
                          </div>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-title">Storyboard Title: * </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input className="request-input" type="text" id="storyboard-details-title" name="storyboard-details-title" placeholder="e.g. Take me home, Country Road – must match Storyboard Name)"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-about">About: * </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input className="request-input" type="text" id="storyboard-details-about" name="storyboard-details-about" placeholder="e.g. A feel good story about how a little kindness goes a long way"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-genre"> Genre:  </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input className="request-input" type="text" id="storyboard-details-genre" name="storyboard-details-genre" placeholder="e.g. Thriller, Dramatic, Emotional, etc"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-length"> Length:  </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input className="request-input" type="text" id="storyboard-details-length" name="storyboard-details-length" placeholder="e.g.  approx. 45 sec"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-tone">  Tone:  </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input className="request-input" type="text" id="storyboard-details-tone" name="storyboard-details-tone" placeholder="e.g. feel good, sunny"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="storyboard-details-cta"> Call to Action:  </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" className="request-input" id="storyboard-details-cta" name="storyboard-details-cta" placeholder="e.g.  Donate money"/>
                          </Col>
                        </FormGroup>
                      </Col>

                      {/* Audience */}
                      <Col xs="12" md="6" className="audience form-section">
                          <FormGroup>
                            <div className="form-section-title">
                              <b>Target Audience</b>
                            </div>
                          </FormGroup>
                          <FormGroup row>
                            <Col md="3">
                              <Label htmlFor="audience-demographic">Demographic:</Label>
                            </Col>
                            <Col xs="12" md="9">
                              <Input type="text" className="request-input" id="audience-demographic" name="audience-demographic" placeholder="e.g. Baby Boomer, Gen X, Gen Y, Millennial, Gen Z, Male, Female, etc"/>
                            </Col>
                          </FormGroup>
                          <FormGroup row>
                            <Col md="3">
                              <Label htmlFor="text-input"> Location: </Label>
                            </Col>
                            <Col xs="12" md="9">
                              <Input type="text" className="request-input" id="audience-location" name="audience-location" placeholder="e.g. Country, State, Town”"/>
                            </Col>
                          </FormGroup>
                      </Col>

                    {/* Client */}
                      <Col xs="12" md="6" className="client form-section">
                        <FormGroup>
                          <div className="form-section-title">
                            <b>Client</b>
                          </div>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="client-contact-name">  Contact Person Name: * </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="client-contact-name" className="request-input" name="client-contact-name" placeholder=""/>
                          </Col>
                        </FormGroup>       
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="client-contact-email">  Contact Person Email: * </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="client-contact-email" name="client-contact-email" className="request-input" placeholder=""/>
                          </Col>
                        </FormGroup>
                      </Col>

                      {/* Creative Team */}
                      <Col xs="12" md="6" className="creative-team form-section">
                        <FormGroup>
                        <div className="form-section-title">
                          <b>Creative Team</b>
                        </div>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="creative-team-vertical">Vertical:</Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="creative-team-vertical" name="creative-team-vertical" className="request-input" placeholder="e.g. Tourism, Philanthropy, Education"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="creative-team-agency-name">Agency Name:</Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="creative-team-agency-name" name="creative-team-agency-name" className="request-input" placeholder="e.g. N/A or Agency Acme Inc"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="creative-team-contact-name"> Contact Person Name: </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="creative-team-contact-name" name="creative-team-contact-name" className="request-input" placeholder="e.g. Canberra"/>
                          </Col>
                        </FormGroup>     
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="creative-team-contact-email">  Contact Person Email: </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="creative-team-contact-email" name="creative-team-contact-email" className="request-input" placeholder=""/>
                          </Col>
                        </FormGroup>                                       
                      </Col>

                      {/* Event */}
                      <Col xs="12" md="6" className="event form-section">
                        <FormGroup>
                          <div className="form-section-title">
                            <b>Event</b>
                          </div>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="event-name">Event Name:</Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="event-name" name="event-name" className="request-input" placeholder="e.g.  Vivid 2018"/>
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="event-start"> Start Date: </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="event-start" name="event-start" className="request-input" placeholder=""/>
                          </Col>
                        </FormGroup>    
                        <FormGroup row>
                          <Col md="3">
                            <Label htmlFor="event-end">  End Date: </Label>
                          </Col>
                          <Col xs="12" md="9">
                            <Input type="text" id="event-end" name="event-end" className="request-input" placeholder=""/>
                          </Col>
                        </FormGroup>                                      
                      </Col>
                    </Row>
                    <Row>
                      <Col >
                        <Button color="success" className="float-right" onClick={this.postForm}>Submit</Button>
                      </Col>
                    </Row>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default StoryRequestPage;



// WEBPACK FOOTER //
// ./src/views/Components/RequestStoryboard/storyRequest.js